/*
 * @Author: PanYunhong
 * @Date: 2022-07-08 13:14:14
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-19 17:55:06
 */
import {
  get, post, postNoData, postRequest,
} from '@/request/request';
import { serverIp, } from '@/configs/index';

/**
 *  溯源列表查询
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const getTraceHisList = (params:any) => post('/gaochun/traceabilityAnalysis/list', params);

/**
 *  根据溯源点id查询单挑数据
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const getTraceInfo = (params:any) => get('/gaochun/traceabilityAnalysis/info', params);

/**
 *  根据溯源点id删除单挑数据
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const deleteTraceInfo = (params:any) => get('/gaochun/traceabilityAnalysis/delete', params);

/**
 *  查询所有自动运行的溯源点5天的点位数据
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const getTraceDefault = (params?:any) => post('/gaochun/traceabilityAnalysis/searchDefaultPointsForFiveDay', params);

/**
 *  查询5天的热力图
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const getHeatMap = (params?:any) => get('/gaochun/traceabilityAnalysis/queryTraceabilityIssue', params);

/*
 *  开始溯源
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const startTraceApi = (params:any) => postRequest('/gaochun/traceabilityAnalysis/runTraceability', params);
